export default "__VITE_ASSET__d671dfb5__"